import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { CartContext } from "../context/CartContext";
import { useNavigate } from "react-router-dom";

export default function Navbar() {
  const { cart } = useContext(CartContext);
  const [search, setSearch] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  // Show admin links only if a token exists
  const isAdmin = !!localStorage.getItem("token");

  const handleSearch = () => {
    if (!search.trim()) return;
    navigate(`/products?search=${encodeURIComponent(search.trim())}`);
    setSearch("");
    setMenuOpen(false);
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700&family=DM+Sans:wght@400;500;600&display=swap');

        .nb{font-family:'DM Sans',sans-serif;width:100%;background:#fff;border-bottom:1px solid #f0ece8;box-shadow:0 1px 12px rgba(0,0,0,0.05);position:sticky;top:0;z-index:999}
        .nb-inner{max-width:1280px;margin:0 auto;padding:0 28px;height:74px;display:flex;align-items:center;justify-content:space-between;gap:16px}

        /* LOGO */
        .nb-logo{display:flex;align-items:center;gap:12px;text-decoration:none;flex-shrink:0}
        .nb-logo-img{height:60px;width:auto;object-fit:contain;border-radius:3px}
        .nb-logo-text{font-family:'Playfair Display',serif;font-size:24px;font-weight:800;color:#1a1410;white-space:nowrap}
        .nb-logo-text span{color:#c87090}

        /* SEARCH */
        .nb-search{display:flex;align-items:center;background:#f7f4f1;border:1.5px solid #ede8e2;border-radius:7px;overflow:hidden;transition:border-color .2s,box-shadow .2s;flex:1;max-width:260px;min-width:0;height:36px}
        .nb-search:focus-within{border-color:#c87090;box-shadow:0 0 0 3px rgba(200,112,144,0.10);background:#fff}
        .nb-search-icon{padding:0 8px 0 11px;color:#bbb;display:flex;align-items:center;flex-shrink:0}
        .nb-search input{border:none;background:transparent;font-size:13px;font-family:'DM Sans',sans-serif;color:#1a1410;width:100%;outline:none;padding:0;height:100%}
        .nb-search input::placeholder{color:#c0b8b0}
        .nb-search-btn{background:#c87090;border:none;color:white;padding:0 12px;height:36px;font-size:11px;font-weight:600;font-family:'DM Sans',sans-serif;cursor:pointer;letter-spacing:.5px;transition:background .18s;flex-shrink:0;white-space:nowrap}
        .nb-search-btn:hover{background:#b05c7a}

        /* NAV LINKS */
        .nb-links{display:flex;align-items:center;gap:2px;flex-shrink:0}
        .nb-link{text-decoration:none;color:#5a524c;font-size:13px;font-weight:500;padding:5px 10px;border-radius:6px;transition:color .18s,background .18s;white-space:nowrap}
        .nb-link:hover{color:#c87090;background:rgba(200,112,144,0.07)}

        /* CART */
        .nb-cart{display:flex;align-items:center;gap:5px;text-decoration:none;color:#1a1410;background:#fff5f8;border:1.5px solid #f5d0dc;padding:4px 11px 4px 9px;border-radius:20px;font-size:12.5px;font-weight:600;transition:all .18s;white-space:nowrap;flex-shrink:0}
        .nb-cart:hover{background:#ffe0ea;border-color:#c87090;color:#c87090}
        .nb-badge{background:#c87090;color:white;border-radius:50%;width:17px;height:17px;display:flex;align-items:center;justify-content:center;font-size:10px;font-weight:700;line-height:1}

        /* DIVIDER */
        .nb-div{width:1px;height:16px;background:#ede8e2;margin:0 3px;flex-shrink:0}

        /* ADMIN BADGE */
        .nb-admin{text-decoration:none;font-size:11.5px;font-weight:600;color:#fff;background:#c87090;border:1px solid #c87090;padding:4px 12px;border-radius:5px;transition:all .18s;white-space:nowrap}
        .nb-admin:hover{background:#b05c7a;border-color:#b05c7a}

        /* HAMBURGER */
        .nb-hamburger{display:none;flex-direction:column;gap:4px;cursor:pointer;padding:6px;flex-shrink:0;background:none;border:none}
        .nb-hamburger span{display:block;width:20px;height:2px;background:#1a1410;border-radius:2px;transition:all .22s}

        /* MOBILE MENU */
        .nb-mobile{display:none;flex-direction:column;gap:0;background:#fff;border-top:1px solid #f0ece8;padding:12px 20px 16px}
        .nb-mobile.open{display:flex}
        .nb-mobile-search{display:flex;align-items:center;background:#f7f4f1;border:1.5px solid #ede8e2;border-radius:7px;overflow:hidden;margin-bottom:10px;height:38px}
        .nb-mobile-search:focus-within{border-color:#c87090}
        .nb-mobile-search input{border:none;background:transparent;font-size:13px;font-family:'DM Sans',sans-serif;color:#1a1410;width:100%;outline:none;padding:0 10px;height:100%}
        .nb-mobile-search button{background:#c87090;color:white;border:none;padding:0 14px;height:38px;font-size:11px;font-weight:600;font-family:'DM Sans',sans-serif;cursor:pointer}
        .nb-mobile-link{text-decoration:none;color:#5a524c;font-size:14px;font-weight:500;padding:10px 4px;border-bottom:1px solid #f4f0ec;display:block;transition:color .18s}
        .nb-mobile-link:hover{color:#c87090}
        .nb-mobile-link:last-child{border-bottom:none}

        /* ADMIN SECTION IN MOBILE MENU */
        .nb-admin-section{
          margin-top:8px;
          border-top:2px solid #f5d0dc;
          padding-top:8px;
          display:flex;
          flex-direction:column;
          gap:0;
        }
        .nb-admin-section-label{
          font-size:9px;font-weight:600;letter-spacing:.2em;
          text-transform:uppercase;color:#c87090;
          padding:6px 4px 4px;
        }
        .nb-mobile-admin-link{
          text-decoration:none;
          color:#1a1410;
          font-size:13.5px;
          font-weight:500;
          padding:9px 4px;
          border-bottom:1px solid #f4f0ec;
          display:flex;
          align-items:center;
          gap:8px;
          transition:color .18s;
        }
        .nb-mobile-admin-link:hover{color:#c87090}
        .nb-mobile-admin-link:last-child{border-bottom:none}
        .nb-mobile-admin-link::before{
          content:'⚙';
          font-size:12px;
          opacity:.5;
        }

        @media(max-width:768px){.nb-links{display:none}.nb-search{display:none}.nb-hamburger{display:flex}}
        @media(max-width:480px){.nb-inner{padding:0 16px}.nb-logo-text{font-size:15px}}
      `}</style>

      <nav className="nb">
        <div className="nb-inner">

          <Link to="/" className="nb-logo">
            <img src="/logo.png" alt="STMZ" className="nb-logo-img" />
            <span className="nb-logo-text">STMZ <span>Group</span></span>
          </Link>

          <div className="nb-search">
            <span className="nb-search-icon">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
              </svg>
            </span>
            <input
              value={search}
              onChange={e => setSearch(e.target.value)}
              onKeyDown={e => e.key === "Enter" && handleSearch()}
              placeholder="Search products..."
            />
            <button onClick={handleSearch} className="nb-search-btn">Search</button>
          </div>

          {/* DESKTOP NAV */}
          <div className="nb-links">
            <Link to="/"             className="nb-link">Home</Link>
            <Link to="/products"     className="nb-link">Shop</Link>
            <Link to="/new-arrivals" className="nb-link">New In</Link>
            <Link to="/track"        className="nb-link">Track</Link>
            <Link to="/contact"      className="nb-link">Contact</Link>
            <div className="nb-div" />
            <Link to="/cart" className="nb-cart">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>
                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
              </svg>
              Cart
              <span className="nb-badge">{cart.length}</span>
            </Link>

            {/* Admin links — visible when logged in */}
            {isAdmin && (
              <>
                <div className="nb-div" />
                <Link to="/admin/dashboard" className="nb-admin">Dashboard</Link>
                <Link to="/admin"           className="nb-link" style={{fontSize:"12.5px"}}>Products</Link>
                <Link to="/admin/orders"    className="nb-link" style={{fontSize:"12.5px"}}>Orders</Link>
              </>
            )}
          </div>

          <button
            className="nb-hamburger"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Menu"
          >
            <span style={menuOpen ? {transform:"rotate(45deg) translate(4px,4px)"} : {}} />
            <span style={menuOpen ? {opacity:0} : {}} />
            <span style={menuOpen ? {transform:"rotate(-45deg) translate(4px,-4px)"} : {}} />
          </button>
        </div>

        {/* MOBILE MENU */}
        <div className={`nb-mobile ${menuOpen ? "open" : ""}`}>
          <div className="nb-mobile-search">
            <input
              value={search}
              onChange={e => setSearch(e.target.value)}
              onKeyDown={e => e.key === "Enter" && handleSearch()}
              placeholder="Search products..."
            />
            <button onClick={handleSearch}>Go</button>
          </div>

          <Link to="/"             className="nb-mobile-link" onClick={() => setMenuOpen(false)}>Home</Link>
          <Link to="/products"     className="nb-mobile-link" onClick={() => setMenuOpen(false)}>Shop</Link>
          <Link to="/new-arrivals" className="nb-mobile-link" onClick={() => setMenuOpen(false)}>New In</Link>
          <Link to="/track"        className="nb-mobile-link" onClick={() => setMenuOpen(false)}>Track Order</Link>
          <Link to="/contact"      className="nb-mobile-link" onClick={() => setMenuOpen(false)}>Contact Us</Link>
          <Link to="/cart"         className="nb-mobile-link" onClick={() => setMenuOpen(false)}>
            Cart ({cart.length})
          </Link>

          {/* Admin section — only when logged in */}
          {isAdmin && (
            <div className="nb-admin-section">
              <span className="nb-admin-section-label">Admin Panel</span>
              <Link to="/admin/dashboard" className="nb-mobile-admin-link" onClick={() => setMenuOpen(false)}>Dashboard</Link>
              <Link to="/admin"           className="nb-mobile-admin-link" onClick={() => setMenuOpen(false)}>Manage Products</Link>
              <Link to="/admin/orders"    className="nb-mobile-admin-link" onClick={() => setMenuOpen(false)}>Manage Orders</Link>
            </div>
          )}
        </div>
      </nav>
    </>
  );
}